module.exports = __webpack_public_path__ + "static/media/15@2x.8a9e3475.png";